module.exports = __webpack_public_path__ + "static/media/IMG_0911-min.20494e82.jpg";